import { render } from "./communityDetail.vue?vue&type=template&id=909ce2b4&scoped=true"
import script from "./communityDetail.vue?vue&type=script&lang=js"
export * from "./communityDetail.vue?vue&type=script&lang=js"

import "./communityDetail.vue?vue&type=style&index=0&id=909ce2b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-909ce2b4"]])

export default __exports__